import React from 'react';
import { Link } from 'react-router-dom';
import { formatDate } from '../../utils/helpers';

const RecentArticles = ({ articles }) => {
  if (!articles || articles.length === 0) {
    return null;
  }

  return (
    <div className="bg-surface rounded-xl p-6 border border-gray-700/30">
      <h3 className="text-lg font-bold text-white mb-4 flex items-center">
        <i className="fas fa-newspaper text-yellow-400 mr-2"></i>
        Articles récents
      </h3>
      <div className="space-y-4">
        {articles.map(article => (
          <Link
            key={article.id}
            to={`/article/${article.slug}`}
            className="block group"
          >
            <div className="flex gap-3">
              {article.featured_image ? (
                <img
                  src={article.featured_image}
                  alt={article.title}
                  className="w-20 h-20 object-cover rounded-lg flex-shrink-0"
                />
              ) : (
                <div className="w-20 h-20 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-lg flex-shrink-0 flex items-center justify-center">
                  <i className="fas fa-newspaper text-2xl text-gray-900 opacity-50"></i>
                </div>
              )}
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-medium text-white group-hover:text-yellow-400 transition-colors line-clamp-2 mb-1">
                  {article.title}
                </h4>
                <p className="text-xs text-gray-500">
                  {formatDate(article.published_at)}
                </p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RecentArticles;
